import {
  TranslateModule,
  TranslateService,
  TranslateLoader,
} from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ListModule } from './components/list/list.module';
import { CurrentUserInfoComponent } from './components/current-user-info/current-user-info.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { LoaderComponent } from './components/loader/loader.component';
import { BreadcrumbComponent } from './components/bread-crump/bread-crump.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxTagsInputModule } from 'ngx-tags-input';
import { NotAuthorizedComponent } from './components/authentication/not-authorized/not-authorized.component';
import { NotFoundComponent } from './components/authentication/not-found/not-found.component';
import { HttpClientModule } from '@angular/common/http';
import { DropDownComponent } from './components/drop-down/drop-down.component';
import { SearchPanelComponent } from './components/search-panel/search-panel.component';
import { ServerErrorComponent } from './components/authentication/server-error/server-error.component';
import { RequestSubmitterInfoComponent } from './components/request-submitter-info/request-submitter-info.component';
import { AttachmentModule } from './common/attachment/attachment.module';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { ViewFileComponent } from './components/view-file/view-file.component';
import { IamCallbackComponent } from './components/authentication/iam-callback/iam-callback.component';
import { InputTextComponent } from './components/textInput/text-input.component';
import { UserInfoComponent } from './components/user-info/user-info.component';
import { CheckAuthDirective } from './directives/auth.directive';
import { NgbCarouselConfig, NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginusingforignerComponent } from './components/authentication/loginusingforigner/loginusingforigner.component';
import { RegisterusingforignerComponent } from './components/authentication/registerusingforigner/registerusingforigner.component';
import { ChangepasswordComponent } from './components/authentication/changepassword/changepassword.component';
import { NotActiveComponent } from './components/authentication/not-active/not-active.component';
import { MainlayoutComponent } from './components/mainlayout/mainlayout.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { CheckIfGovAgencyUserDirective } from './directives/CheckIfGovAgencyUser';
import { CrNumberComponent } from './components/cr-number/cr-number.component';
import { CompleteCompanyComponent } from './components/complete-company/complete-company.component';
import { LoginTypeComponent } from './components/login-type/login-type.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DropDownMultiSelectComponent } from './components/drop-down-multi-select/drop-down-multi-select.component';
import { NotificationsListComponent } from '../modules/services/license/notification-log/components/notifications-list/notifications-list.component';
import { NotificationListModule } from './components/notification-list/notification-list.module';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    CurrentUserInfoComponent,
    SideMenuComponent,
    LoaderComponent,
    BreadcrumbComponent,
    NotAuthorizedComponent,
    ServerErrorComponent,
    NotFoundComponent,
    DropDownComponent,
    DropDownMultiSelectComponent,
    SearchPanelComponent,
    RequestSubmitterInfoComponent,
    FileUploadComponent,
    ViewFileComponent,
    IamCallbackComponent,
    InputTextComponent,
    UserInfoComponent,
    CheckAuthDirective,    
    CheckIfGovAgencyUserDirective,
    LoginusingforignerComponent,
    RegisterusingforignerComponent,
    ChangepasswordComponent,
    
    
    NotActiveComponent,
                MainlayoutComponent,
                CrNumberComponent,
                CompleteCompanyComponent,
                LoginTypeComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    HttpClientModule,
    ListModule,
    NotificationListModule,
    AttachmentModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxTagsInputModule,
    NgbCarouselModule,
    BsDatepickerModule.forRoot()
  ],
  exports: [
    TranslateModule,
    HeaderComponent,
    FooterComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ListModule,
    NotificationListModule,
    CurrentUserInfoComponent,
    SideMenuComponent,
    LoaderComponent,
    BreadcrumbComponent,
    NgMultiSelectDropDownModule,
    NgxTagsInputModule,
    DropDownComponent,
    DropDownMultiSelectComponent,
    SearchPanelComponent,
    RequestSubmitterInfoComponent,
    AttachmentModule,
    FileUploadComponent,
    ViewFileComponent,
    InputTextComponent,
    CheckAuthDirective,
    CheckIfGovAgencyUserDirective,
    NgxIntlTelInputModule
  ],
  providers: [TranslateService, NgbCarouselConfig],
})
export class SharedModule {}
